import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
const BestValueBadge = ({
  message = 'bestValue',
  props
}) => /*#__PURE__*/_jsx(Badge, Object.assign({
  use: "new"
}, props, {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `badges.${message}`
  })
}));
export default BestValueBadge;